import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-background-100/80">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-book-read-line text-xl text-primary-400"></i>
              </div>
              <span className="font-heading text-lg text-background-50">
                韩漫在线阅读网
              </span>
            </div>
            <p className="text-sm text-background-100/60 leading-relaxed">
              韩国漫画免费看，全网韩漫全集同步更新。提供恋爱、奇幻、校园等多种类型热门韩漫推荐，为读者打造最优质的免费韩漫阅读平台。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">
              分类浏览
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/category/romance" className="text-sm text-background-100/60 hover:text-primary-400 transition-colors">
                  恋爱韩漫
                </Link>
              </li>
              <li>
                <Link to="/category/fantasy" className="text-sm text-background-100/60 hover:text-primary-400 transition-colors">
                  奇幻韩漫
                </Link>
              </li>
              <li>
                <Link to="/category/school" className="text-sm text-background-100/60 hover:text-primary-400 transition-colors">
                  校园韩漫
                </Link>
              </li>
              <li>
                <Link to="/category/action" className="text-sm text-background-100/60 hover:text-primary-400 transition-colors">
                  动作韩漫
                </Link>
              </li>
              <li>
                <Link to="/category/mystery" className="text-sm text-background-100/60 hover:text-primary-400 transition-colors">
                  悬疑韩漫
                </Link>
              </li>
              <li>
                <Link to="/category/drama" className="text-sm text-background-100/60 hover:text-primary-400 transition-colors">
                  剧情韩漫
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">
              快速链接
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-background-100/60 hover:text-primary-400 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-100/60 hover:text-primary-400 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#latest" className="text-sm text-background-100/60 hover:text-primary-400 transition-colors">
                  最新更新
                </a>
              </li>
              <li>
                <a href="#popular" className="text-sm text-background-100/60 hover:text-primary-400 transition-colors">
                  热门推荐
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">
              联系我们
            </h4>
            <ul className="space-y-2 text-sm text-background-100/60">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>contact@hanman-online.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line"></i>
                <span>韩国首尔特别市</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-100/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-100/40">
            &copy; {currentYear} 韩漫在线阅读网. All rights reserved.
          </p>
          <p className="text-xs text-background-100/40">
            本站所有漫画资源均来自网络，仅供学习交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}